import {
  kontentImage,
  Image,
  KontentMediaIcon,
  kontentVectorArt,
} from "../types";
import { stripHtml } from "./descriptions";
import { getMultiChoice } from "./multichoice";

export function formatImages(mediaImage: kontentImage["elements"]): {
  largeImage: Image;
  smallImage: Image;
} {
  return {
    largeImage: {
      item: mediaImage?.image?.value[0],
      alt: stripHtml(mediaImage?.image?.value[0].description),
      caption: mediaImage?.caption,
      focalPoint: getMultiChoice(mediaImage?.focal_point),
    },
    smallImage: {
      item: mediaImage?.small_image?.value[0],
      alt: stripHtml(mediaImage?.small_image?.value[0]?.description),
      caption: mediaImage?.caption,
      focalPoint: getMultiChoice(mediaImage?.focal_point),
    },
  };
}

export function formatIcon(mediaIcon: KontentMediaIcon["elements"]): Image {
  return {
    item: mediaIcon?.icon?.value[0],
    alt: stripHtml(mediaIcon?.icon?.value[0]?.description),
  };
}

export function formatVector(vector: kontentVectorArt["elements"]): Image {
  return {
    item: vector?.vector?.value[0],
    alt: stripHtml(vector?.vector?.value[0]?.description || ""),
  };
}
